// extracted by mini-css-extract-plugin
module.exports = {"divider":"styles_divider__3uqqL"};